// extracted by mini-css-extract-plugin
export default {"container":"style_container__8fSpd","card":"style_card__e+9Yu","title":"style_title__3q20W","description":"style_description__CulGq","boldDescription":"style_boldDescription__ZLDEm"};